import { getCwUrl } from '../utils/config';
import { getFetch, putFetch } from '../utils/fetch';

export const getCourseExceptions = async (courseId) => {
  const baseUrl = `${getCwUrl()}/api/v3`;
  const response = await getFetch(`${baseUrl}/courses/${courseId}/exceptions`);
  if (!response.ok) {
    throw new Error('Unable to get course exceptions');
  }
  return response.json();
};

export const updateAssignmentException = async (payload, assignmentId) => {
  const baseUrl = `${getCwUrl()}/api/v3`;
  const endPoint = `${baseUrl}/exceptions/bulk/upsert`;
  const response = await putFetch(endPoint, payload);
  if (!response.ok) {
    throw new Error(`Unable to update exception for ${assignmentId}`);
  }
  return response.json();
};
